/**
 * Global chunk loading error handler
 * Handles ChunkLoadError which occurs when chunks are not found (usually after deployment)
 */

// Listen for chunk loading errors globally
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    // Check if it's a chunk loading error
    const isChunkError = event.message && (
      event.message.includes('Loading chunk') ||
      event.message.includes('ChunkLoadError') ||
      event.message.includes('Failed to fetch dynamically imported module')
    );

    if (isChunkError) {
      console.warn('Chunk loading error detected. Attempting to reload page...', event);
      
      // Store that we're reloading to prevent infinite loops
      const reloading = sessionStorage.getItem('chunk-reloading');
      if (!reloading) {
        sessionStorage.setItem('chunk-reloading', 'true');
        
        // Clear after 5 seconds to allow retry if reload fails
        setTimeout(() => {
          sessionStorage.removeItem('chunk-reloading');
        }, 5000);
        
        // Clear cache and reload
        if ('caches' in window) {
          caches.keys().then(names => {
            names.forEach(name => caches.delete(name));
          });
        }
        window.location.reload();
      }
    }
  }, true);

  // Also listen for unhandled promise rejections (chunk errors often show up here)
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    const isChunkError = error && (
      error.message && (
        error.message.includes('Loading chunk') ||
        error.message.includes('ChunkLoadError') ||
        error.message.includes('Failed to fetch dynamically imported module')
      )
    );

    if (isChunkError) {
      console.warn('Chunk loading error in promise rejection. Attempting to reload page...', error);
      event.preventDefault(); // Prevent default error handling
      
      const reloading = sessionStorage.getItem('chunk-reloading');
      if (!reloading) {
        sessionStorage.setItem('chunk-reloading', 'true');
        
        setTimeout(() => {
          sessionStorage.removeItem('chunk-reloading');
        }, 5000);
        
        // Clear cache and reload
        if ('caches' in window) {
          caches.keys().then(names => {
            names.forEach(name => caches.delete(name));
          });
        }
        window.location.reload();
      }
    }
  });
}

// Export utility function to manually handle chunk errors
export const handleChunkError = (error) => {
  if (error && (
    error.name === 'ChunkLoadError' ||
    (error.message && error.message.includes('Loading chunk'))
  )) {
    console.warn('Chunk error detected, clearing cache and reloading...');
    // Clear cache and reload
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    window.location.reload();
    return true;
  }
  return false;
};

const chunkErrorUtils = {
  handleChunkError
};

export default chunkErrorUtils;

